
import EditCompetencyMgmtPeriodComponent from '../../components/admin/EditCompetencyMgmtPeriodComponent';

const EditCompetencyMgmtPeriod = () => {
  return (
    <div>
      <EditCompetencyMgmtPeriodComponent />
    </div>
  );
};

export default EditCompetencyMgmtPeriod;